export const getAuthor = (story) => {
  if (story && story.author) {
    const { firstname, lastname, pseudo } = story.author
    return pseudo ? pseudo : firstname + ' ' + lastname
  }
  return 'Inconnu'
}